import {
  ATFIcon,
  KaspiIcon,
  HalykIcon,
  JusanIcon,
  HomeCreditIcon,
  BCKIcon,
  VTBIcon,
  EurasianIcon,
  NurIcon,
  FreedomIcon,
  VisaIcon,
  MasterCardIcon,
  RBKIcon,
  BerekeIcon,
  HilalIcon,
  ForteIcon,
} from 'assets/icons/banks';
import { list } from 'constants/banks';

const bankNames = Object.keys(list);

type IconType = {
  [key: string]: () => JSX.Element;
};

const getIcons: IconType = {
  vtb: VTBIcon,
  forte: ForteIcon,
  jusan: JusanIcon,
  bereke: BerekeIcon,
  kaspi: KaspiIcon,
  halyk: HalykIcon,
  homecredit: HomeCreditIcon,
  rbk: RBKIcon,
  nur: NurIcon,
  atf: ATFIcon,
  freedom: FreedomIcon,
  bck: BCKIcon,
  hilal: HilalIcon,
  eurasian: EurasianIcon,
};

const getCardTypeIcon = (type = '') => {
  if (type) {
    if (type === 'VISA') {
      return VisaIcon;
    }

    if (type === 'MASTERCARD') {
      return MasterCardIcon;
    }
  }

  return null;
};

const validateCardType = (value = '') => {
  const cardNumber = value.replace(/\s/g, '');

  if (cardNumber) {
    if (cardNumber.startsWith('4')) {
      return VisaIcon;
    }

    if (cardNumber.startsWith('5')) {
      return MasterCardIcon;
    }
  }

  return null;
};

const validateCard = (value = '') => {
  const cardNumber = value.replace(/\s/g, '');

  let icon: JSX.Element | null = null;

  if (cardNumber) {
    if (cardNumber.length >= 10) {
      const code = cardNumber.substring(0, 10);
      bankNames.forEach((key) => {
        list[key].forEach(({ from, to }) => {
          if (from && to && code >= from && code <= to.toString() && getIcons[key] !== undefined) {
            icon = getIcons[key]();
          }
        });
      });
    }

    if (cardNumber.length >= 6) {
      const code = cardNumber.substring(0, 6);
      bankNames.forEach((key) => {
        list[key].forEach(({ from, to }) => {
          const fromShort = from.substring(0, 6);

          if (from && to && code === fromShort && getIcons[key] !== undefined) {
            icon = getIcons[key]();
          }
        });
      });
    }
  }

  return icon;
};

const luhnAlgorithm = (digits: string) => {
  const clearDigits = digits.replace(/\s/g, '');
  let sum = 0;
  let double = false;

  for (let i = clearDigits.length - 1; i >= 0; i -= 1) {
    let digit = parseInt(clearDigits[i], 10);

    if (double) {
      digit *= 2;

      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;

    double = !double;
  }

  return sum % 10 === 0;
};

export { getCardTypeIcon, validateCardType, validateCard, luhnAlgorithm };
